import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/products",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/dashboard/index.vue"),
      },
      {
        path: "/card_records",
        name: "card_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_records/index.vue"),
      },
      {
        path: "/gift_records",
        name: "gift_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/gift_records/index.vue"),
      },
      {
        path: "/gift_records/new",
        name: "gift_record_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/gift_records/new.vue"),
      },
      {
        path: "/box_records",
        name: "all_box_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_records/index.vue"),
      },
      {
        path: "/water_items",
        name: "water_items",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/water_items/index.vue"),
      },
      {
        path: "/loser_items",
        name: "loser_items",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/loser_items/index.vue"),
      },
      {
        path: "/asset_loser_items",
        name: "asset_loser_items",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/asset_loser_items/index.vue"),
      },
      {
        path: "/product_brands",
        name: "product_brands",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/product_brands/index.vue"),
      },
      {
        path: "/product_brands/new",
        name: "product_brand_new",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/product_brands/new.vue"),
      },
      {
        path: "/product_brands/:id/edit/",
        name: "product_brand_edit",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/product_brands/edit.vue"),
      },
      {
        path: "/ips",
        name: "ips",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/ips/index.vue"),
      },
      {
        path: "/ips/new",
        name: "ip_new",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/ips/new.vue"),
      },
      {
        path: "/ips/:id/edit/",
        name: "ip_edit",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/ips/edit.vue"),
      },{
        path: "/compound_categories",
        name: "compound_categories",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/compound_categories/index.vue"),
      },
      {
        path: "/compound_categories/new",
        name: "compound_category_new",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/compound_categories/new.vue"),
      },
      {
        path: "/compound_categories/:id/edit/",
        name: "compound_category_edit",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/compound_categories/edit.vue"),
      },
      {
        path: "/lottery_signs",
        name: "lottery_signs",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/lottery_signs/index.vue"),
      },
      {
        path: "/lottery_signs/new",
        name: "lottery_sign_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/lottery_signs/new.vue"),
      },
      {
        path: "/lottery_signs/:id/edit/",
        name: "lottery_sign_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/lottery_signs/edit.vue"),
      },
      {
        path: "/compounds",
        name: "compounds",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/compounds/index.vue"),
      },
      {
        path: "/compounds/records",
        name: "compound_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/components/compounds/Records.vue"),
      },
      {
        path: "/compounds/new",
        name: "compound_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/compounds/new.vue"),
      },
      {
        path: "/compounds/:id/edit/",
        name: "compound_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/compounds/edit.vue"),
      },
      {
        path: "/banners",
        name: "banners",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/banners/index.vue"),
      },
      {
        path: "/products",
        name: "products",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/products/index.vue"),
      },
      {
        path: "/products/new",
        name: "product_new",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/products/new.vue"),
      },
      {
        path: "/products/:id/edit/",
        name: "product_edit",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: false
        },
        component: () => import("@/views/apps/products/edit.vue"),
      },
      {
        path: "/events",
        name: "events",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/events/index.vue"),
      },
      {
        path: "/events/new",
        name: "event_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/events/new.vue"),
      },
      {
        path: "/events/edit",
        name: "event_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/events/edit.vue"),
      },
      {
        path: "/shipping_orders",
        name: "shipping_orders",
        meta: {
          roles: ['admin', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/shipping_orders/index.vue"),
      },
      {
        path: "/shipping_orders/:id/edit/",
        name: "shipping_order_edit",
        meta: {
          roles: ['admin', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/shipping_orders/edit.vue"),
      },
      {
        path: "/user_members",
        name: "members",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/members/index.vue"),
      },
      {
        path: "/user_members/:id/edit/",
        name: "member_edit",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/members/edit.vue"),
      },
      {
        path: "/user_members/:id/report_days",
        name: "member_report_days",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/members/report_days.vue"),
      },
      {
        path: "/change_logs",
        name: "change_logs",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/change_logs/index.vue"),
      },
      {
        path: "/payment_records",
        name: "payment_records",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/payment_records/index.vue"),
      },
      {
        path: "/add_balance_records",
        name: "add_balance_records",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/add_balance_records/index.vue"),
      },
      {
        path: "/payment_traces",
        name: "payment_traces",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/components/payment_traces/Index.vue"),
      },
      {
        path: "/add_balance_records/new",
        name: "add_balance_record_new",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/add_balance_records/new.vue"),
      },
      {
        path: "/operating_costs",
        name: "operating_costs",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/operating_costs/index.vue"),
      },
      {
        path: "/remove_balance_records",
        name: "remove_balance_records",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/remove_balance_records/index.vue"),
      },
      {
        path: "/remove_balance_records/new",
        name: "remove_balance_record_new",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/remove_balance_records/new.vue"),
      },
      {
        path: "/add_point_records",
        name: "add_point_records",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/add_point_records/index.vue"),
      },
      {
        path: "/add_point_records/new",
        name: "add_point_record_new",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/add_point_records/new.vue"),
      },
      {
        path: "/add_extra_point_records",
        name: "add_extra_point_records",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/add_extra_point_records/index.vue"),
      },
      {
        path: "/add_extra_point_records/new",
        name: "add_extra_point_record_new",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/add_extra_point_records/new.vue"),
      },
      {
        path: "/box_infos",
        name: "box_infos",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_infos/index.vue"),
      },
      {
        path: "/box_infos/new",
        name: "box_info_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_infos/new.vue"),
      },
      {
        path: "/box_infos/:id/edit/",
        name: "box_info_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_infos/edit.vue"),
      },
      {
        path: "/box_infos/:id/boxes",
        name: "boxes",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/boxes/index.vue"),
      },
      {
        path: "/box_infos/:box_info_id/boxes/:id/box_records",
        name: "box_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_records/index.vue"),
      },
      {
        path: "/box_categories",
        name: "box_categories",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_categories/index.vue"),
      },
      {
        path: "/box_categories/new",
        name: "box_category_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_categories/new.vue"),
      },
      {
        path: "/box_categories/:id/edit/",
        name: "box_category_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/box_categories/edit.vue"),
      },
      // {
      //   path: "/users",
      //   name: "users",
      //   meta: {
      //     roles: ['admin']
      //   },
      //   component: () => import("@/views/apps/users/index.vue"),
      // },
      {
        path: "/shop_banners",
        name: "shop_banners",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/shop_banners/index.vue"),
      },
      {
        path: "/user_banners",
        name: "user_banners",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/user_banners/index.vue"),
      },
      {
        path: "/system_settings/deliver_note",
        name: "deliver_note",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/system_settings/deliver_note.vue"),
      },
      {
        path: "/system_settings/shipping_fee_config",
        name: "shipping_fee_config",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/system_settings/shipping_fee_config.vue"),
      },
      {
        path: "/system_settings/settlement_pause",
        name: "settlement_pause",
        meta: {
          roles: ['admin'],
          keepAlive: false
        },
        component: () => import("@/views/apps/system_settings/settlement_pause.vue"),
      },
      {
        path: "/system_settings/excluded_gain_categories",
        name: "excluded_gain_categories",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/system_settings/excluded_gain_categories.vue"),
      },
      {
        path: "/system_settings/eat_cook_categories",
        name: "eat_cook_categories",
        meta: { roles: ['admin'] },
        component: () => import("@/views/apps/system_settings/eat_cook_categories.vue"),
      },
      {
        path: "/admins",
        name: "admins",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/admins/index.vue"),
      },
      {
        path: "/admins/new",
        name: "admin_new",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/admins/new.vue"),
      },
      {
        path: "/admins/:id/edit/",
        name: "admin_edit",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/admins/edit.vue"),
      },
      {
        path: "/distributions",
        name: "distributions",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/distributions/index.vue"),
      },
      {
        path: "/distributions/new",
        name: "distribution_new",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/distributions/new.vue"),
      },
      {
        path: "/distributions/:id/edit",
        name: "distribution_edit",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/distributions/edit.vue"),
      },
      {
        path: "/distributions/:distribution_id/users",
        name: "distribution_users",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/distribution_users/index.vue"),
      },
      {
        path: "/shipping_products",
        name: "shipping_products",
        component: () => import("@/components/shipping_products/Index.vue"),
        meta: {
          middleware: "auth",
          roles: ['admin', 'goods']
        }
      },
      {
        path: "/user_pocket_items",
        name: "pocket_items",
        component: () => import("@/components/pocket_items/Index.vue"),
        meta: {
          requiresAuth: true,
          roles: ['admin']
        }
      },
      {
        path: "/shipping_records",
        name: "shipping_records",
        component: () => import("@/components/shipping_records/Index.vue"),
        meta: {
          roles: ['admin', 'goods']
        }
      },
      {
        path: "/profit_records",
        name: "profit_records",
        meta: {
          roles: ['admin'],
          keepAlive: true
        },
        component: () => import("@/views/apps/profit_records/index.vue"),
      },
      {
        path: "/mall_products",
        name: "mall_products",
        meta: {
          roles: ['admin', 'operation', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/mall_products/index.vue"),
      },
      {
        path: "/mall_orders",
        name: "mall_orders",
        meta: {
          roles: ['admin', 'goods'],
          keepAlive: true
        },
        component: () => import("@/views/apps/mall_orders/index.vue"),
      },
      {
        path: "/mall_orders/:id/edit/",
        name: "mall_order_edit",
        meta: {
          roles: ['admin', 'goods'],
          keepAlive: false
        },
        component: () => import("@/views/apps/mall_orders/edit.vue"),
      },
      {
        path: "/mall_coupons",
        name: "mall_coupons",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/mall_coupons/index.vue"),
      },
      {
        path: "/mall_coupons/new",
        name: "mall_coupon_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/mall_coupons/new.vue"),
      },
      {
        path: "/mall_coupons/:id/edit/",
        name: "mall_coupon_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/mall_coupons/edit.vue"),
      },
      {
        path: "/mall_coupons/:id/usage",
        name: "mall_coupon_usage",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/mall_coupons/usage.vue"),
      },
      // 抽赏优惠券管理
      {
        path: "/lottery_coupons",
        name: "lottery_coupons",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/lottery_coupons/index.vue"),
      },
      {
        path: "/lottery_coupons/new",
        name: "lottery_coupon_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/lottery_coupons/new.vue"),
      },
      {
        path: "/lottery_coupons/:id/edit/",
        name: "lottery_coupon_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/lottery_coupons/edit.vue"),
      },
      {
        path: "/lottery_coupons/:id/usage",
        name: "lottery_coupon_usage",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/lottery_coupons/usage.vue"),
      },
      // 明信片奖励配置管理
      {
        path: "/postcard_reward_configs",
        name: "postcard_reward_configs",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/postcard_rewards/configs/index.vue"),
      },
      {
        path: "/postcard_reward_configs/new",
        name: "postcard_reward_config_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/postcard_rewards/configs/new.vue"),
      },
      {
        path: "/postcard_reward_configs/:id/edit",
        name: "postcard_reward_config_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/postcard_rewards/configs/edit.vue"),
      },
      // 明信片奖励发放记录
      {
        path: "/postcard_reward_logs",
        name: "postcard_reward_logs",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/postcard_rewards/logs/index.vue"),
      },
      // 抽卡系统 - 卡牌系列
      {
        path: "/card_series",
        name: "card_series",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_series/index.vue"),
      },
      {
        path: "/card_series/new",
        name: "card_series_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_series/new.vue"),
      },
      {
        path: "/card_series/:id/edit",
        name: "card_series_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/card_series/edit.vue"),
      },
      // 抽卡系统 - 稀有度管理
      {
        path: "/card_rarities",
        name: "card_rarities",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_rarities/index.vue"),
      },
      {
        path: "/card_rarities/new",
        name: "card_rarities_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_rarities/new.vue"),
      },
      {
        path: "/card_rarities/:id/edit",
        name: "card_rarities_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/card_rarities/edit.vue"),
      },
      // 抽卡系统 - 语系管理
      {
        path: "/card_languages",
        name: "card_languages",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_languages/index.vue"),
      },
      {
        path: "/card_languages/new",
        name: "card_languages_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_languages/new.vue"),
      },
      {
        path: "/card_languages/:id/edit",
        name: "card_languages_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/card_languages/edit.vue"),
      },
      // 抽卡系统 - 版本管理
      {
        path: "/card_versions",
        name: "card_versions",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_versions/index.vue"),
      },
      {
        path: "/card_versions/new",
        name: "card_versions_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_versions/new.vue"),
      },
      {
        path: "/card_versions/:id/edit",
        name: "card_versions_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/card_versions/edit.vue"),
      },
      // 抽卡系统 - 卡牌管理
      {
        path: "/cards_management",
        name: "cards_management",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/cards_management/index.vue"),
      },
      {
        path: "/cards_management/new",
        name: "cards_management_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/cards_management/new.vue"),
      },
      {
        path: "/cards_management/:id/edit",
        name: "cards_management_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/cards_management/edit.vue"),
      },
      // 抽卡系统 - 卡池管理
      {
        path: "/card_pools",
        name: "card_pools",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_pools/index.vue"),
      },
      {
        path: "/card_pools/new",
        name: "card_pools_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_pools/new.vue"),
      },
      {
        path: "/card_pools/:id/edit",
        name: "card_pools_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/card_pools/edit.vue"),
      },
      // 抽卡系统 - 抽卡记录
      {
        path: "/card_draw_records",
        name: "card_draw_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/card_draw_records/index.vue"),
      },
      // 冲冲赏记录
      {
        path: "/run_gift_records",
        name: "run_gift_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/run_gift_records/index.vue"),
      },
      {
        path: "/product_gift_records",
        name: "product_gift_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/product_gift_records/index.vue"),
      },
      // 对对碰系统 - 池子管理
      {
        path: "/match_pools",
        name: "match_pools",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/match_pools/index.vue"),
      },
      {
        path: "/match_pools/new",
        name: "match_pools_new",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/match_pools/new.vue"),
      },
      {
        path: "/match_pools/:id/edit",
        name: "match_pools_edit",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/match_pools/edit.vue"),
      },
      {
        path: "/match_pools/:id/stats",
        name: "match_pools_stats",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/match_pools/stats.vue"),
      },
      // 对对碰系统 - 游戏记录
      {
        path: "/match_game_records",
        name: "match_game_records",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: true
        },
        component: () => import("@/views/apps/match_game_records/index.vue"),
      },
      {
        path: "/match_game_records/:id",
        name: "match_game_record_detail",
        meta: {
          roles: ['admin', 'operation'],
          keepAlive: false
        },
        component: () => import("@/views/apps/match_game_records/detail.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH);

  // console.log(to)
  // console.log(to.meta.roles)
  // console.log(store.getters.currentUser)
  // console.log(store.getters.currentUser.role)

  if (to.meta.roles) {
    if (store.getters.currentUser) {
      if((to.meta.roles as Array<string>).includes(store.getters.currentUser.role)) {
        next()
      } else {
        next({ path: "/404" })
      }
    } else {
      next()
    }
  } else {
    next()
  }

  // console.log("router")
  // console.log(store.getters.currentUser)
  // next()

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
